<template>
    <div class="type_area">
      <Bread :direct="direct" :bgc="bgc"></Bread>
      <div style="text-align: center;"><img src="@/assets/coupons.png" alt=""></div>
      <el-divider></el-divider>
      <div class="list_box" v-if="couponList.length">
            <div class="list_item"  v-for="(item,index) in couponList" :key="index">
                <div class="item_left">
                    <span v-if="item.couponType==1" class="amount"><span>￥</span>{{item.reduceMoney}}</span>
                    <span v-if="item.couponType==2" class="amount">{{item.discount}}折</span>
                    <span>{{item.description}}</span>
                </div>
                <div class="item_right">
                    <div class="top">
                        <span v-if="item.couponType==1">满减券</span>
                        <span v-if="item.couponType==2" class="active">满折券</span>
                        {{ item.tips }}
                    </div>
                    <div class="date">有效期：</div>
                    <div class="date">{{item.startTime}}~{{item.endTime}}</div>
                </div>
                <div class="btn_box" v-if="item.isUse"  @click="goUse">立即使用</div>
                <div class="btn_box" v-else  @click="getCoupon(item)">立即领取</div>
               
                <div class="tag_box" v-if="item.isUse">
                    <img  src="@/assets/images/personal/ylq.png" alt="">
                    <!-- <img v-else src="@/assets/images/personal/coupon_ysx.svg" alt=""> -->
                </div>
            </div>
        </div>
        <div class="nodata_box" v-else>
            <img src="@/assets/images/index/nodata.png" alt="">
            <span >暂无可用优惠券哦~</span>
            <!-- <span v-if="activeName == '1'">暂无已使用优惠券哦~</span>
            <span v-if="activeName == '2'">暂无已失效优惠券哦~</span> -->
        </div>
    </div>
  </template>
  
  <script>
  import Bread from '@/components/Bread'
  export default {
    name: 'Coupon',
      components: {
          Bread
      },
   data() {
          return {
              direct: ['首页', '领劵中心'],
              bgc: '#f3f3f3',
              couponList: [],
          }
      },
      created() {
        this.getCouponList()
      },
      mounted() {
      },
      methods: {
        getCouponList() {
            this.$api.getCouponCenter().then((res) => {
              if (res.data.code === 200) {
                res.data.data.forEach(item => {
                    item.isUse = false
                })
                this.couponList = res.data.data?res.data.data:[]
              }
            });
        },
     async   getCoupon(item){
        if(item.isUse){
            this.$message.warning('该优惠券已领取')
            return
        }
         const res = await   this.$api.getCoupons({id:item.id})
         if(res.data.code === 200){
             this.$message.success('领取成功')
             item.isUse = true
         }
        },
        goUse(){
          this.$router.push('/onlineOrder')
        },
      }
  }
  </script>
  
  <style lang="scss" scoped>


    .list_box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .list_item {
            position: relative;
            width: 288px;
            height: 74px;
            display: flex;
            align-items: flex-start;
            margin: 0 14px 14px 0;
            background: url('~@/assets/images/orderInfo/special.png') no-repeat;
            background-size: 100% 100%;
            font-size: 10px;
            color: #ffffff;

            &.disabled {
                background: url('~@/assets/images/orderInfo/no-special.png')
                    no-repeat;
                background-size: 100% 100%;
                color: #ff8c8c;

                .date {
                    color: #fe9e9e;
                }
            }

            &:nth-of-type(4n) {
                margin-right: 0;
            }

            .btn_box {
                position: absolute;
                top: 30px;
                right: 11px;
                width: 35px;
                height: 13px;
                line-height: 13px;
                text-align: center;
                border-radius: 100px 100px 100px 100px;
                border: 1px solid #f2b2bb;
                font-weight: bold;
                font-size: 7px;
                color: #ffe6e9;
                cursor: pointer;
            }

            .tag_box {
                position: absolute;
                top: 0;
                right: 0;
            }

            .item_left {
                flex-shrink: 0;
                width: 79px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .amount {
                    padding: 11px 0 4px;
                    font-size: 23px;

                    span {
                        font-size: 9px;
                    }
                }
            }
            .item_right {
                padding: 9px 0 0 25px;

                .top {
                    font-size: 14px;
                    margin-bottom: 2px;
                    display: flex;
                    align-items: center;
                    font-weight: 600;

                    span {
                        display: inline-block;
                        width: 28px;
                        height: 12px;
                        line-height: 12px;
                        text-align: center;
                        border: 1px solid #feeac3;
                        border-radius: 2px;
                        margin-right: 7px;
                        font-weight: bold;
                        font-size: 7px;
                        color: #ffe7b7;

                        &.active {
                            color: #ffbfc6;
                            border-color: #ffbfc6;
                        }
                    }
                }
            }
        }
    }

  </style>